import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CategoryOnlineReportContent from './CategoryOnlineReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchCategoryOnlineFullReport } from './categoryOnlineReportSlice';

const CategoryOnlineReportManager = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(
            fetchCategoryOnlineFullReport({
                fromDate: today,
                toDate: today,
                branchId: storedBranchId
            })
        );
    }, [dispatch, storedBranchId, storedBranchName]);

    return <CategoryOnlineReportContent isManagerView />;
};

export default CategoryOnlineReportManager;
